export interface Comarca {
    code: number;
    name: string;
    name_article: string;
  }
  
  export const comarques: Comarca[] = [
    {
        "code": 1,
        "name_article": "L'Alacantí",
        "name": "Alacantí"
       },
       {
        "code": 2,
        "name_article": "L'Alcalatén",
        "name": "Alcalatén"
       },
       {
        "code": 3,
        "name_article": "L'Alcoià",
        "name": "Alcoià"
       },
       {
        "code": 4,
        "name_article": "L'Alt Maestrat",
        "name": "Alt Maestrat"
       },
       {
        "code": 5,
        "name_article": "L'Alt Millars",
        "name": "Alt Millars"
       },
       {
        "code": 6,
        "name_article": "L'Alt Palància",
        "name": "Alt Palància"
       },
       {
        "code": 7,
        "name_article": "L'Alt Vinalopó",
        "name": "Alt Vinalopó"
       },
       {
        "code": 8,
        "name_article": "El Baix Maestrat",
        "name": "Baix Maestrat"
       },
       {
        "code": 9,
        "name_article": "El Baix Segura",
        "name": "Baix Segura"
       },
       {
        "code": 10,
        "name_article": "El Baix Vinalopó",
        "name": "Baix Vinalopó"
       },
       {
        "code": 11,
        "name_article": "El Camp de Morvedre",
        "name": "Camp de Morvedre"
       },
       {
        "code": 12,
        "name_article": "El Camp de Túria",
        "name": "Camp de Túria"
       },
       {
        "code": 13,
        "name_article": "La Canal de Navarrés",
        "name": "Canal de Navarrés"
       },
       {
        "code": 14,
        "name_article": "El Comtat",
        "name": "Comtat"
       },
       {
        "code": 15,
        "name_article": "La Costera",
        "name": "Costera"
       },
       {
        "code": 16,
        "name_article": "La Foia de Bunyol",
        "name": "Foia de Bunyol"
       },
       {
        "code": 17,
        "name_article": "L'Horta Nord",
        "name": "Horta Nord"
       },
       {
        "code": 18,
        "name_article": "L'Horta Sud",
        "name": "Horta Sud"
       },
       {
        "code": 19,
        "name_article": "La Marina Alta",
        "name": "Marina Alta"
       },
       {
        "code": 20,
        "name_article": "La Marina Baixa",
        "name": "Marina Baixa"
       },
       {
        "code": 21,
        "name_article": "La Plana Alta",
        "name": "Plana Alta"
       },
       {
        "code": 22,
        "name_article": "La Plana Baixa",
        "name": "Plana Baixa"
       },
       {
        "code": 23,
        "name_article": "La Plana d'Utiel-Requena",
        "name": "Plana d'Utiel-Requena"
       },
       {
        "code": 24,
        "name_article": "Els Ports",
        "name": "Ports"
       },
       {
        "code": 25,
        "name_article": "El Racó d'Ademús",
        "name": "Racó d'Ademús"
       },
       {
        "code": 26,
        "name_article": "La Ribera Alta",
        "name": "Ribera Alta"
       },
       {
        "code": 27,
        "name_article": "La Ribera Baixa",
        "name": "Ribera Baixa"
       },
       {
        "code": 28,
        "name_article": "La Safor",
        "name": "Safor"
       },
       {
        "code": 29,
        "name_article": "Els Serrans",
        "name": "Serrans"
       },
       {
        "code": 30,
        "name_article": "València",
        "name": "València"
       },
       {
        "code": 31,
        "name_article": "La Vall d'Albaida",
        "name": "Vall d'Albaida"
       },
       {
        "code": 32,
        "name_article": "La Vall de Cofrents-Aiora",
        "name": "Vall de Cofrents-Aiora"
       },
       {
        "code": 33,
        "name_article": "El Vinalopó Mitjà",
        "name": "Vinalopó Mitjà"
       }
  ];


export function getComarcaName(language: string, code: number) {
    const found = comarques.find((comarca) => comarca.code == code);

    if(found !== undefined){
        return found.name;
    } else{
        return undefined;
    }
}

export function getComarcaNameWithArticle(language: string, code: number) {
    const found = comarques.find((comarca) => comarca.code == code);

    if(found !== undefined){
        return found.name_article;
    } else{
        return undefined;
    }
}

